import { City, State } from "country-state-city";
import { API, axiosInstance } from "lib";
import StorageService from "utils/StorageServices/StorageServices";
const TRANSPORT_MODE = process.env.REACT_APP_TRANSPORT_MODE;

 const GET_DASHBOARD_DATA =
  TRANSPORT_MODE !== "production"
    ? API.GET_COMPANY
    : API.GET_COMPANY;


export const allCities = () => {
    const filteredcity =
        City &&
        City.getCitiesOfCountry("IN")

    const optionsCity = filteredcity?.map((d) => {
        return {
            ...d,
            label: `${d?.name}, ${d?.stateCode}`,
            value: d?.name
        };
    });

    StorageService.setCities(JSON.stringify([...optionsCity]))
};

export const allStates = () => {
    const FilterState = State && State.getStatesOfCountry("IN")
    const optionsState = FilterState?.map((d) => {
        return {
            ...d,
        };
    });

    StorageService.setStates(JSON.stringify([...optionsState]))
};

export const getCitiesData = (data = {}) => {
    return axiosInstance
        .post(API.GET_CITIES, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            return err?.response?.data
        });
};

export const getStatesData = (data) => {
    return axiosInstance
        .post(
            API.GET_COUNTRY_STATES, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export function handleKeyDown(event, maxDecimals = 2) {

    function isValidNumber(val) {
        if (val === "") return true;
        return !!(!isNaN(val) && !isNaN(parseFloat(val)));
    }

    function isSpace(str) {
        return str === " ";
    }

    function isWhitelistedKey(key) {
        const whitelistedActions = [
            "Backspace",
            "ArrowLeft",
            "ArrowRight",
            "ArrowUp",
            "ArrowDown",
            "Tab",
            "Delete",
            "."
        ];
        return whitelistedActions.includes(key);
    }

    const currentValue = event.target.value;
    const key = event.key;
    const cursorPosition = event.target.selectionStart; // ✅ Cursor position

    // ✅ Decimal limit check - but only AFTER decimal point
    if (currentValue.includes('.') && !isWhitelistedKey(key)) {
        const dotIndex = currentValue.indexOf('.');
        const decimalPart = currentValue.split('.')[1];

        // ✅ Only prevent if typing AFTER the decimal point
        if (cursorPosition > dotIndex && 
            decimalPart && 
            decimalPart.length >= maxDecimals && 
            /^\d$/.test(key)) {
            event.preventDefault();
            return;
        }
    }

    if (isWhitelistedKey(key)) {
        // Allow only one dot
        if (key === '.' && currentValue.includes('.')) {
            event.preventDefault();
        }
    } else if (isSpace(key) || !isValidNumber(currentValue + key)) {
        event.preventDefault();
    }
}
// ✅ Function to restrict to integers only
export function restrictIntegerInput(value) {
    if (value === "") return value;
    if (value === "0") return value;

    // Remove leading zeros
    if (/^0[0-9]/.test(value)) {
        value = value.replace(/^0+/, '');
    }

    // ❌ Block if contains dot or decimal
    if (value.includes('.')) {
        return null;
    }

    // Only allow digits
    if (!/^\d+$/.test(value)) {
        return null;
    }

    return value;
}

// ✅ Updated handleKeyDown - block dot when maxDecimals = 0
export function handleKeyDownDe(event, maxDecimals = 2) {
    const currentValue = event.target.value;
    const key = event.key;
    const cursorPosition = event.target.selectionStart;

    const whitelistedActions = [
        "Backspace",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Delete"
    ];

    // ❌ Block dot if maxDecimals is 0 (integer only)
    if (key === '.' && maxDecimals === 0) {
        event.preventDefault();
        return;
    }

    // Allow dot only if decimals allowed
    if (maxDecimals > 0) {
        whitelistedActions.push(".");
    }

    // Decimal limit check
    if (currentValue.includes('.') && !whitelistedActions.includes(key)) {
        const dotIndex = currentValue.indexOf('.');
        const decimalPart = currentValue.split('.')[1];

        if (cursorPosition > dotIndex && 
            decimalPart && 
            decimalPart.length >= maxDecimals && 
            /^\d$/.test(key)) {
            event.preventDefault();
            return;
        }
    }

    if (whitelistedActions.includes(key)) {
        if (key === '.' && currentValue.includes('.')) {
            event.preventDefault();
        }
    } else if (key === ' ' || isNaN(currentValue + key) || (currentValue + key) === '') {
        event.preventDefault();
    }
}
export const getMasterData = (data = {}) => {
    return axiosInstance
        .get(
            API.GET_MASTER_DATA, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getCompanyList = (data = {}) => {
    return axiosInstance
        .get(
            API.GET_MASTER_DATA, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getDashbordData = (data = {}) => {
    return axiosInstance
        .post(
          GET_DASHBOARD_DATA, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getMasterRole = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_MASTER_ROLE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getRole = (data = {}) => {
    return axiosInstance
        .post(
            API.ROLE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const deleteRole = (data = {}) => {
    return axiosInstance
        .post(
            API.ROLE_DELETE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const consignorGroup = (data = {}) => {
    return axiosInstance
        .post(
            API.CONSIGNOR_GROUP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getUser = (data = {}) => {
    return axiosInstance
        .post(
            API.USER, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const deleteUser = (data = {}) => {
    return axiosInstance
        .post(
            API.DELETE_USER, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getallowedmenus = (data = {}) => {
    return axiosInstance
        .post(
            API.MENU, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getallowedmenus2 = (data = {}) => {
    return axiosInstance
        .post(
            API.MENU_2, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getRoleDetail = (data = {}) => {
    return axiosInstance
        .post(
            API.ROLE_DETAILS, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const updateRoles = (data = {}) => {
    return axiosInstance
        .post(
            API.ROLE_UPDATE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getAllAccount = (data = {}) => {
    return axiosInstance
        .post(
            API.ALL_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAllRoutes = (data = {}) => {

    return axiosInstance
        .post(
            API.ALL_ROUTE, data)
        .then((response) => {

            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAllVehicleNumber = (data = {}) => {

    return axiosInstance
        .post(
            API.ALL_VEHICLE_NUMBER, data)
        .then((response) => {

            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAllDriver = (data = {}) => {

    return axiosInstance
        .post(
            API.ALL_DRIVERS, data)
        .then((response) => {

            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAllSupplier = (data = {}) => {

    return axiosInstance
        .post(
            API.ALL_SUPPLIER, data)
        .then((response) => {

            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAllBranchDropdwon = (data = {}) => {

    return axiosInstance
        .post(
            API.ALL_BRANCH, data)
        .then((response) => {

            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAllLrApi = (data = {}) => {

    return axiosInstance
        .post(
            API.ALL_LR, data)
        .then((response) => {

            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getTrip = (data = {}) => {
    return axiosInstance
        .post(
            API.TRIP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getDispatchedTrip = (data = {}) => {
    return axiosInstance
        .post(
            API.DISPATCH_TRIP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getTransactionList = (data = {}) => {
    return axiosInstance
        .post(
            API.TRANSACTION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getFreightMasterApi = (data = {}) => {
    return axiosInstance
        .post(
            API.FREIGHT_TYPE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getVenderBankList = (data = {}) => {
    return axiosInstance
        .post(
            API.BANK_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAccountFreghtList = (data = {}) => {
    return axiosInstance
        .post(
            API.CHART_OF_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAccountList = (data = {}) => {
    return axiosInstance
        .post(
            API.ACCOUNT_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getUserAccount = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_USER_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const lrListofTrip = (data = {}) => {
    return axiosInstance
        .post(
            API.LR_LIST_TRIP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getExpense = (data = {}) => {
    return axiosInstance
        .post(
            API.EXPENSE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getChartExpense = (data = {}) => {
    return axiosInstance
        .post(
            API.CHART_EXPENSE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getChartRecipt = (data = {}) => {
    return axiosInstance
        .post(
            API.CHART_RECIPT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getCommonExpenseApi = (data = {}) => {
    return axiosInstance
        .post(
            API.COMMON_EXPENSE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};



export const getUserAccountList = (data = {}) => {
    return axiosInstance
        .post(
            API.USER_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAccountingUser = (data = {}) => {
    return axiosInstance
        .post(
            API.ACCOUNTING_GET_USER, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getAccountingTransaction = (data = {}) => {
    return axiosInstance
        .post(
            API.ACCOUNTING_TRANSACTION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getPaynowAccountingTransaction = (data = {}) => {
    return axiosInstance
        .post(
            API.PAYNOW_ACCOUNT_TRANSACTION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getPayment = (data = {}) => {
    return axiosInstance
        .post(
            API.PAYMENT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const paymentCountApi = (data = {}) => {
    return axiosInstance
        .post(
            API.PAYMENT_COUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getConsignorTransactionList = (data = {}) => {
    return axiosInstance
        .post(
            API.CONSIGNOR_TRAN, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getLastTrip = (data = {}) => {
    return axiosInstance
        .post(
            API.LAST_TRIP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getBuiltyApi = (data = {}) => {
    return axiosInstance
        .post(
            API.BUILTY, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getTripCount = (data = {}) => {
    return axiosInstance
        .post(
            API.TRIP_COUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getUserPermissionApi = (data = {}) => {
    return axiosInstance
        .post(
            API.USER_PERMISSION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAddUserBranch = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_ADD_USER_BRANCH, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
}



export const vehicleGroup = (data = {}) => {
    return axiosInstance
        .post(
            API.VEHICLE_GROUP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getTotalFreightDetais = (data = {}) => {
    return axiosInstance
        .post(
            API.TOTAL_FREIGHT_DETAILS, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getAddressListApi = (data = {}) => {
    return axiosInstance
        .post(
            API.COMMON_DROPDOWN + `get_addressbook_for_dropdown`, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getMarketVisiblityApi = (data = {}) => {
    return axiosInstance
        .post(
            API.MARKET_VISIBLITY_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const createCashAccountApi = (data = {}) => {
    return axiosInstance
        .post(
            API.CASH_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const createBankAccountApi = (data = {}) => {
    return axiosInstance
        .post(
            API.BANK_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const createOtherAccountApi = (data = {}) => {
    return axiosInstance
        .post(
            API.OTHER_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const createFuelAccountApi = (data = {}) => {
    return axiosInstance
        .post(
            API.ADD_FUEL_CARD_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const createFastagAccountApi = (data = {}) => {
    return axiosInstance
        .post(
            API.ADD_FASTAG_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getAdvanceDriverCategory = (data = {}) => {
    return axiosInstance
        .post(
            API.ADVANCE_DRIVER_CAT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const addExpenseAccount = (data = {}) => {
    return axiosInstance
        .post(
            API.ADD_EXPENSE_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getTripTransactionDispatch = (data = {}) => {
    return axiosInstance
        .post(
            API.TRIP_TRANSACTION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getTripRevenue = (data = {}) => {
    return axiosInstance
        .post(
            API.TRIP_REVENUE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getFuelCardMaster = (data = {}) => {
    return axiosInstance
        .post(
            API.FUEL_CARD_MASTER, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const addFuelCardMaster = (data = {}) => {
    return axiosInstance
        .post(
            API.ADD_FUEL_CARD_MASTER, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const fuelCardAccount = (data = {}) => {
    return axiosInstance
        .post(
            API.FUEL_CARD_ACCOUNT_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const addDriverFromTrip = (data = {}) => {
    return axiosInstance
        .post(
            API.UPDATE_TRIP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
};

export const createFuelOutApi = (data = {}) => {
    return axiosInstance
        .post(
            API.CREATE_FUEL_OUT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
};

export const addExpenseApi = (data = {}) => {
    return axiosInstance
        .post(
            API.ADD_EXPENSE_API, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
};


export const getFuelRateApi = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_FUEL_RATE, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
}

export const deleteTransactionApi = (data = {}) => {
    return axiosInstance
        .post(
            API.DELETE_TRANSACTION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
}

export const venderDropdownApi = (data = {}) => {
    return axiosInstance
        .post(
            API.VENDER_DROPDOWN, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
}

export const transferFundApi = (data = {}) => {
    return axiosInstance
        .post(
            API.TRANSFER_FUND, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
}

export const createFuelOutown = (data = {}) => {
    return axiosInstance
        .post(
            API.CREATE_FUEL_OWN, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
}

export const getRoleMasters = (data = {}) => {
    return axiosInstance
        .post(API.GET_ROLE_MASTERS, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
};

export const getSinglePlanSubscription = (data = {}) => {
    return axiosInstance
        .post(API.GET_SINGLE_PLAN_SUBSCRIPTION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {

            return error?.response?.data

        });
};

export const getFastagMaster = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_FASTAG_MASTER, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const addFastagMaster = (data = {}) => {
    return axiosInstance
        .post(
            API.ADD_FASTAG_MASTER, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const addFastagAccount = (data = {}) => {
    return axiosInstance
        .post(
            API.ADD_FASTAG_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const fastagAccount = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_FASTAG_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getBuiltyPrint = (data = {}) => {
    return axiosInstance
        .get(
            API.GET_BUILTY2 + `/${data?.formate?.formate}` + `/${data?.company_id}` + `/${data?.trip_id}?no_of_pages=${data?.formate?.page}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};



export const builtyDownload = (data = {}) => {
    return axiosInstance
        .post(
            API.BUILY_DOWNLOAD2, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const paymentVoucherApi = (data = {}) => {
    return axiosInstance
        .post(
            API.PAYMENT_VOUCHER, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const makePaymentApi = (data = {}) => {
    return axiosInstance
        .post(
            API.MAKE_PAYMENT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const addLoadApi = (data = {}) => {
    return axiosInstance
        .post(
            API.ADD_LOAD, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const cancelTripApi = (data = {}) => {
    return axiosInstance
        .post(
            API.CANCEL_TRIP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getBankListApi = (data = {}) => {
    return axiosInstance
        .post(
            API.PAYMENT_BANK_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getPaymentExcelDownload = (data = {}) => {
    return axiosInstance
        .post(
            API.PAYMENT_BANK_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const updateTripApi = (data = {}) => {
    return axiosInstance
        .post(
            API.UPDATE_TRIP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

/// sim Tracking //

export const updateDriverConsentApi = (data = {}) => {
    return axiosInstance
        .post(
            API.DRIVER_CONSENT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const fatchLocationSimApi = (data = {}) => {
    return axiosInstance
        .post(
            API.FATCH_LOCATION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const fecthTripLoaction = (data = {}) => {
    return axiosInstance
        .post(
            API.TRIP_FETCH_LOCATION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};



export const getConsignorInvoiceTransactionList = (data = {}) => {
    return axiosInstance
        .post(
            API.INVOICE_TRANSACTION, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getInvoiceLrPodPrint = (data = {}) => {
    let paramUrl = `?no_of_pages=${data?.no_of_pages ? data?.no_of_pages : ''}&lr_with_pod=${data?.lr_with_pod ? data?.lr_with_pod : 0}&pageSize=${data?.pageSize ? data?.pageSize : ''}&layout=${data?.layout ? data?.layout : ''}`
    return axiosInstance
        .get(
            API.GET_INVOICE_LR_POD + `/${data?.invoice_format}` + `/${data?.company_id}` + `/${data?.lr_id}` + paramUrl) 
            // API.GET_INVOICE_LR_POD + `/${data?.invoice_format}` + `/${data?.company_id}` + `/${data?.trip_id}` + `/${data?.lr_id}` + paramUrl)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getPreviewInvoiceLrPod = (data = {}) => {
    return axiosInstance
        .get(
            API.PREVIEW_PRINT_INVOICE_LR_POD + `?company_id=${data?.company_id}&trip_id=${data?.trip_id}&lr_id=${data?.lr_id}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};



///////////////////////
// supplier Trip Report 

export const getSupplerReportApi = (data = {}) => {
    return axiosInstance
        .get(
            `${API.SUPPLIER_TRIP_REPORT}?company_id=${data?.company_id}&trip_id=${data?.trip_id}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getSupplerReportApi2 = (data = {}) => {
    return axiosInstance
        .get(
            `${API.SUPPLIER_TRIP_REPORT2}?company_id=${data?.company_id}&supplier_id=${data?.supplier_id}&start_date=${data?.start_date}&end_date=${data?.end_date}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getCompanyCheck = (data = {}) => {
    return axiosInstance
        .post(
            API.COMPANY_CHECK, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const deleteLrFromTripApi = (data = {}) => {
    return axiosInstance
        .post(
            API.LR_DELETE_TRIP, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getAllDropdownTripApi = (data = {}) => {
    return axiosInstance
        .post(
            API.TRIP_DROPDOWN_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};





////////Driver trip Report 

export const getDriverReportApi = (data = {}) => {
    return axiosInstance
        .get(
            `${API.DRIVER_TRIP_REPORT}?company_id=${data?.company_id}&trip_id=${data?.trip_id}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getLocationDetailsApi = (data = {}) => {
    return axiosInstance
        .post(`https://pro.ip-api.com/json?key=vUjaSOlQ4RnPU1B`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            return err?.response?.data
        });
};

export const addGeneralReceiptInAccounting = (data = {}) => {
    return axiosInstance
        .post(
            API.ADD_GENERAL_RECIEPT_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getLanguageData = (data) => {
    return axiosInstance
        .get(
            API.GET_LANGUAGES + `?is_master_view=${data?.is_master_view}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getPartyLrReport = (data = {}) => {
    return axiosInstance
        .get(
            `${API.PARTY_LR_REPORT}/report?company_id=${data?.company_id}&consignor_id=${data?.consignor_id}&start_date=${data?.start_date}&end_date=${data?.end_date}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getTripReportTemplate = (data = {}) => {
    return axiosInstance
        .get(
            API.SHEET + `/supplier/trip-report?trip_id=${data?.trip_id}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getTripConsignorReportTemplate = (data = {}) => {
    return axiosInstance
        .get(
            API.SHEET + `/party/trip_report` + `/${data?.trip_id}/${data?.consignor_id}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const updateCashAccountApi = (data = {}) => {
    return axiosInstance
        .post(
            API.UPDATE_CASH_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const updateBankAccountApi = (data = {}) => {
    return axiosInstance
        .post(
            API.UPDATE_BANK_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const updateOtherAccountApi = (data = {}) => {
    return axiosInstance
        .post(
            API.UPDATE_OTHER_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const firmBranchAccountUserApi = (data = {}) => {
    return axiosInstance
        .post(
            API.USER_FIRM_DETAILS, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const interFirmTripDetailsApi = (data = {}) => {
    return axiosInstance
        .post(
            API.INTRE_FIRM_TRIP_DETAILS, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};


export const getEasebuzzConfigurationApi = (data = {}) => {
    return axiosInstance
        .post(
            API.GET_EASEBUZZ_DETAILS, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const verifyConfigurationApi = (data = {}) => {
    return axiosInstance
        .post(
            API.VERIFY_EASEBUZZ_CONFIG, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const makePaymentPayNowApi = (data = {}) => {
    return axiosInstance
        .post(
            API.MAKE_PAYMENT_PAYNOW, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getPaymentDetailsApi = (data = {}) => {
    return axiosInstance
        .post(
            API.PAYMENT_DETAILS_PAYNOW, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};

export const getPaynowStatementDownlaod = (data = {}) => {
    return axiosInstance
        .post(
            API.PAYNOW_STATEMENT_DOWNLOAD, data)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error?.response?.data
        });
};






// ✅ Helper function to format days
 export const formatDaysToDuration = (days) => {
    if (days <= 365) {
        return `${days} ${days === 1 ? 'Day' : 'Days'}`;
    }

    const years = Math.floor(days / 365);
    const remainingDays = days % 365;
    const months = Math.floor(remainingDays / 30);
    const finalDays = remainingDays % 30;

    let parts = [];
    
    if (years > 0) {
        parts.push(`${years} ${years === 1 ? 'Year' : 'Years'}`);
    }
    if (months > 0) {
        parts.push(`${months} ${months === 1 ? 'Month' : 'Months'}`);
    }
    if (finalDays > 0) {
        parts.push(`${finalDays} ${finalDays === 1 ? 'Day' : 'Days'}`);
    }

    return parts.join(', ');
};